export default __webpack_public_path__ + "static/media/H_Underlay.6c8f0dc3.jpg";